module.exports = __webpack_public_path__ + "static/media/Pre-dorset_paleo-eskimo_icon_200px.b2a2cad5.png";